import React from 'react'
import ComplexTableApp from 'components/ComplexTableApp'
import SimpleTableApp from 'components/SimpleTableApp'
import NoTableApp from 'components/NoTableApp'
import CartCounter from 'components/CartCounter'
import Flux from 'Flux'

let flux = new Flux()

let prepareTableData = data => {
	return Object.keys(data).map(key => {
		data[key]['id'] = key
		return data[key]
	})
}

//Complex table
let complexNode = document.querySelector('.js-complex-table')
if(complexNode && window.COMPLEX_DATA) {
	window.COMPLEX_DATA.data = prepareTableData(window.COMPLEX_DATA.data).filter(item => item.mass.length && item.thick.length).map(item => {
		item.thick = parseFloat(item.thick)
		item.mass = parseFloat(item.mass)
		return item
	})

	React.render(<ComplexTableApp {...window.COMPLEX_DATA} productId={window.PRODUCT_ID} flux={flux} />, complexNode)
}

//Simple table
let simpleNode = document.querySelector('.js-simple-table')
if(simpleNode && window.SIMPLE_DATA) {
	React.render(
		<SimpleTableApp
			{...window.SIMPLE_DATA}
			filters={detectSimpleFilters(window.SIMPLE_DATA.data)}
			productId={window.PRODUCT_ID}
			flux={flux}
			/>,
		simpleNode
	)
}

//No table
let noTableNode = document.querySelector('.js-no-table')
if(noTableNode) {
	React.render(<NoTableApp productId={window.PRODUCT_ID} flux={flux} />, noTableNode)
}

//Cart counters
let cartCounterNodes = Array.prototype.slice.call(document.querySelectorAll('.js-cart-counter'))
if(cartCounterNodes.length) {
	cartCounterNodes.forEach(node => React.render(<CartCounter flux={flux} />, node))
}

function detectSimpleFilters(data) {
	const keys = Object.keys(data);
	return data[keys[0]].map((v, i) => {
		return keys.reduce((memo, key) => {
			if(memo.type === 'none') {
				return memo;
			}

			const value = data[key][i];
			const parsedValue = parseFloat(value);
			if(`${parsedValue}` == value && memo.type !== 'enum') {
				if(memo.values.indexOf(parsedValue) === -1) {
					return {
						...memo,
						type: 'number',
						values: [
							...memo.values,
							parsedValue
						]
					};
				}
			} else if(`${value}`.length > 20) {
				return {
					type: 'none'
				};
			} else if(value != null && memo.values.indexOf(value) === -1) {
				return {
					...memo,
					type: 'enum',
					values: [
						...memo.values,
						value
					]
				}
			}

			return memo;
		}, {type: null, i, values: []});
	}).filter(filter => {
		return (
			(filter.type === 'enum' && (filter.values.length < 8 && filter.values.length > 1)) ||
			filter.type === 'number'
		);
	}).map(filter => {
		if(filter.type === 'number' && filter.values.length < 4) {
			return {
				...filter,
				type: 'enum'
			};
		} else {
			return filter;
		}
	});
}


/** WEBPACK FOOTER **
 ** ./src/scripts/react-app.js
 **/